import React from 'react';
import styled from '@emotion/styled';

const FooterContainer = styled.footer`
  padding: 2rem;
  background: #0a0a0c;
  text-align: center;
  color: #b0b0b0;
`;

const FooterText = styled.p`
  margin: 0;
  font-size: 0.9rem;
`;

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterText>
        &copy; {new Date().getFullYear()} Contact Manager. All rights reserved.
      </FooterText>
    </FooterContainer>
  );
};

export default Footer;

